


// Home Feature Products

export const dataFeatureProducts = 
[
    {
        "id": 0,
        "image": "/assets/product_assets/PXE-C80-88/PXE-C80-88_Carrousel_1.jpg", 
        "title": "PXE-C80-88", 
        "description":"Procesador y amplificador de sonido de 8 canales OPTIM8® con ajuste automático de sonido via smartphone o PC (AutoEQ 2.0)",
    }, 
    {
        "id": 1,
        "image": "/assets/product_assets/iLX-F509/iLX-F509_agl_Sound_Home_US-AU-AP-JP.jpg", 
        "title": "ILX-F509", 
        "description":"Receptor multimedia digital Alpine Halo9 de 9 pulgadas con pantalla HD y reproducción de audio Hi-Res",
    }, 
    {
        "id": 2,
        "image": "/assets/product_assets/iLX-W770/iLX-W770_Detail_4.jpg", 
        "title": "ILX-W770", 
        "description":"Receptor multimedia digital de 7 pulgadas con conectividad inalámbrica Apple CarPlay & Android Auto",
    }, 
    {
        "id": 3,
        "image": "/assets/product_assets/Alpine_Status_Speakers/HDZ-653_Carrousel_1.jpg", 
        "title": "HDZ-653", 
        "description":"Conjunto componente Hi-Res de 6-1/2 pulgadas de 3 vías Alpine Status",
    }, 
    {
        "id": 4,
        "image": "/assets/product_assets/S2-SB12V/S2-SB12V_Carrousel_1.jpg", 
        "title": "S2-SB12", 
        "description":"Caja Alpine Halo de subwoofer precargada Serie S de próxima generación de 12 pulgadas con ProLink™",
    }, 
    {
        "id": 5,
        "image": "/assets/product_assets/SPB-65/SPB-65_Carrousel_1.jpg", 
        "title": "SPB-65", 
        "description":"Altavoz coaxial de 6-1/2 pulgadas de 3 vías Serie B",
    }, 
];




